import {Component, effect, ElementRef, HostListener, inject, OnInit, viewChild} from '@angular/core';
import {
    KoMatchDtoFixed,
    KoStandingsEndpointService,
    ThirdPlaceMatchDto,
    ThirdPlaceMatchEndpointService
} from "@api";
import {ActivatedRoute} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";

@Component({
    selector: 'app-infoscreen-knockout-phase-fixed',
    standalone: true,
    imports: [
        MatIconModule
    ],
    templateUrl: './infoscreen-knockout-phase-fixed.component.html',
    styleUrl: './infoscreen-knockout-phase-fixed.component.scss'
})
export class InfoscreenKnockoutPhaseFixedComponent implements OnInit {


    koStandingsEndpoint = inject(KoStandingsEndpointService);
    thirdPlaceMatchEndpoint = inject(ThirdPlaceMatchEndpointService)
    route = inject(ActivatedRoute);
    refreshInterval: number | undefined;


    koMatches: KoMatchDtoFixed[] = [];
    matchThirdPlace: ThirdPlaceMatchDto | undefined;
    match3rdPlaceText = viewChild.required<ElementRef>('text3rdPlace');
    match3rdPlaceContainer = viewChild.required<ElementRef>('match3rdPlaceContainer');


    ngOnInit() {
        this.loadData();
        this.refreshInterval = window.setInterval(() => this.loadData(), 3000);
    }


    loadData = () => {
        this.route.params.subscribe(params => {
                this.koStandingsEndpoint.getKoStandingsTreeFixed(Number.parseInt(params.tournamentId)).subscribe({
                    next: value => {
                        this.koMatches = value.reverse();

                        if (this.match3rdPlaceContainer() && this.match3rdPlaceText()) {
                            const targetRect = this.match3rdPlaceContainer().nativeElement.getBoundingClientRect();
                            this.match3rdPlaceText().nativeElement.style.top = `${targetRect.top - 50}px`
                            this.match3rdPlaceText().nativeElement.style.left = `${targetRect.left}px`
                        }
                    }
                })
                this.thirdPlaceMatchEndpoint.getThirdMatchByTournament(params.tournamentId)
                    .subscribe({
                        next: value => {
                            this.matchThirdPlace = value;
                        }
                    })

            }
        );
    };

    getPositionStyle(column: number, row: number): string {
        if (column == 0) {
            return `grid-area: ${(row * 2) + 1} / ${column + 1} / ${(row * 2) + 3}`;
        }
        if (column == 1) {
            const rowInColumn = (row - 8);
            return `grid-area: ${2 + (rowInColumn * 4)} / ${column + 1} / ${4 + (rowInColumn * 4)}`;
        }
        if (column == 2) {
            const rowInColumn = (row - 8 - 4);
            return `grid-area: ${4 + (rowInColumn * 8)} / ${column + 1} / ${6 + (rowInColumn * 8)}`;
        }
        //column 3
        return `grid-area: 8 / ${column + 1} / 10`;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        if (this.match3rdPlaceContainer() && this.match3rdPlaceText()) {
            const targetRect = this.match3rdPlaceContainer().nativeElement.getBoundingClientRect();
            this.match3rdPlaceText().nativeElement.style.top = `${targetRect.top - 50}px`
            this.match3rdPlaceText().nativeElement.style.left = `${targetRect.left}px`
        }
    }
}